import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DSEnea } from 'src/app/_interfaces/dsEnea';
import { DsEneaService } from 'src/app/_services/ds-enea.service/ds-enea.service';

@Component({
  selector: 'app-dialog-enea',
  templateUrl: './dialog-enea.component.html',
  styleUrls: ['./dialog-enea.component.scss']
})



export class DialogEneaComponent implements OnInit {
  @Input() idLavoro = 0;
  @Input() display = false;
  @Output() displayChange = new EventEmitter<boolean>();

  infissoForm!: FormGroup;
  infissi: DSEnea[] = [];

  editingRowId: number | null = null;
  dialogClosable = false;
  
  telaioOptions = [
    { label: 'Legno', value: 'Legno' },
    { label: 'PVC', value: 'PVC' },
    { label: 'Metallo taglio termico', value: 'Metallo taglio termico' },
    { label: 'Metallo NO taglio termico', value: 'Metallo NO taglio termico' },
    { label: 'Misto', value: 'Misto' }
  ];

  vetroOptions = [
    { label: 'Singolo', value: 'Singolo' },
    { label: 'Doppio', value: 'Doppio' },
    { label: 'Triplo', value: 'Triplo' },
    { label: 'A bassa Emissione', value: 'A bassa Emissione' },
    { label: 'Nessuno', value: 'Nessuno' },
    { label: 'Policarbonato', value: 'Policarbonato' },
    { label: 'Pannello Opaco', value: 'Pannello Opaco' }
  ];

  oscuranteOptions = [
    { label: 'SI', value: 1 },
    { label: 'NO', value: 0 }
  ];


  occorrenze = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6', value: 6 },
    { label: '7', value: 7 },
    { label: '8', value: 8 },
    { label: '9', value: 9 },
    { label: '10', value: 10 },
    { label: '11', value: 11 },
    { label: '12', value: 12 },
    { label: '13', value: 13 },
    { label: '14', value: 14 },
    { label: '15', value: 15 },
    { label: '16', value: 16 },
    { label: '17', value: 17 },
    { label: '18', value: 18 },
    { label: '19', value: 19 },
    { label: '20', value: 20 }
  ];

  trasmittanzaMap: { [key: string]: { [key: string]: number } } = {
    'Singolo': {
      'Legno': 5.0,
      'PVC': 5.0,
      'Metallo taglio termico': 5.3,
      'Metallo NO taglio termico': 6.0,
      'Misto': 5.2
    },
    'Doppio': {
      'Legno': 3.0,
      'PVC': 3.0,
      'Metallo taglio termico': 3.5,
      'Metallo NO taglio termico': 4.1,
      'Misto': 3.2
    },
    'Triplo': {
      'Legno': 2.1,
      'PVC': 2.1,
      'Metallo taglio termico': 2.5,
      'Metallo NO taglio termico': 3.4,
      'Misto': 2.4
    }
  };

  ruoloUtente: string = "SE";

  constructor(
    private fb: FormBuilder,
    private dsEneaSrv: DsEneaService,
    private messageSrv: MessageService,
    private confirmService: ConfirmationService,) { }

  ngOnInit() {
    this.ruoloUtente = sessionStorage.getItem('ruolo');
    console.log('this.ruoloUtente', this.ruoloUtente);
    this.infissoForm = this.fb.group({
      dse_id: [0, Validators.required],
      dse_lavoro_id: [this.idLavoro, Validators.required],
      dse_step: ['2.6', Validators.required],
      dse_telaio_prima: ['', Validators.required],
      dse_pannello_prima: ['', Validators.required],
      dse_trasm_vecchia: ['', Validators.required],
      dse_superficie: [{ value: '', disabled: this.ruoloUtente === 'SE' },],
      dse_telaio_dopo: ['', Validators.required],
      dse_pannello_dopo: ['', Validators.required],
      dse_trasm_nuova: [{ value: '', disabled: this.ruoloUtente === 'SE' },],
      dse_confine: ['', Validators.required],
      dse_oscurante: ['', Validators.required],
      dse_note: [''],
      dse_occorrenze: [1, Validators.required],
    });

    this.caricaInfissi();

    // ▶️ Inserisci qui gli eventi che ascoltano le modifiche ai dropdown
    this.infissoForm.get('dse_pannello_prima')?.valueChanges.subscribe(() => {
      this.setTrasmittanzaStimata();
    });

    this.infissoForm.get('dse_telaio_prima')?.valueChanges.subscribe(() => {
      this.setTrasmittanzaStimata();
    });

    // this.infissoForm.get('dse_pannello_dopo')?.valueChanges.subscribe(() => {
    //   this.setTrasmittanzaStimataNuova();
    // });

    // this.infissoForm.get('dse_telaio_dopo')?.valueChanges.subscribe(() => {
    //   this.setTrasmittanzaStimataNuova();
    // });

  }

  chiudiDialog() {
    this.displayChange.emit(false);
  }

  setTrasmittanzaStimata() {
    const valore = this.calcolaTrasmittanzaStimata();
    this.infissoForm.get('dse_trasm_vecchia')?.setValue(valore);
  }

  // setTrasmittanzaStimataNuova() {
  //   const valore = this.calcolaTrasmittanzaStimataNuova();
  //   this.infissoForm.get('dse_trasm_nuova')?.setValue(valore);
  // }



  calcolaTrasmittanzaStimata(): string {
    const vetro = this.infissoForm.get('dse_pannello_prima')?.value;
    const telaio = this.infissoForm.get('dse_telaio_prima')?.value;

    if (this.trasmittanzaMap[vetro] && this.trasmittanzaMap[vetro][telaio] !== undefined) {
      return this.trasmittanzaMap[vetro][telaio].toFixed(1).replace('.', ',');
    }

    return '0';
  }

  calcolaTrasmittanzaStimataNuova(): string {
    const vetro = this.infissoForm.get('dse_pannello_dopo')?.value;
    const telaio = this.infissoForm.get('dse_telaio_dopo')?.value;

    if (this.trasmittanzaMap[vetro] && this.trasmittanzaMap[vetro][telaio] !== undefined) {
      return this.trasmittanzaMap[vetro][telaio].toFixed(1).replace('.', ',');
    }

    return '0';
  }


 caricaInfissi() {
  this.dsEneaSrv.getDsEnea(this.idLavoro).subscribe((res) => {
    this.infissi = [...res.data];
    if (res.data && res.data.length > 0) {
      this.dialogClosable = true;
    }
  });
}

  aggiungiInfisso() {
    if (this.infissoForm.valid) {
      this.dsEneaSrv.addDsEnea(this.infissoForm.value).subscribe((res) => {
        this.messageSrv.add({
          key: 'tst',
          severity: res.res === 'ok' ? 'success' : 'error',
          summary: res.res === 'ok' ? 'Salva' : 'Errore',
          detail: res.res === 'ok' ? 'Infisso/i inserito con successo' : 'Erroe durante l\'inserimento',
          life: 5000
        });
        if (res.res === 'ok') { this.resetForm(); }
        this.caricaInfissi();
      });
    }
  }

  salvaModifica(infisso: DSEnea) {
    this.dsEneaSrv.updDsEnea(infisso).subscribe((res) => {
      this.messageSrv.add({
        key: 'tst',
        severity: res.res === 'ok' ? 'success' : 'error',
        summary: res.res === 'ok' ? 'Modifica' : 'Errore',
        detail: res.res === 'ok' ? 'Infisso/i modificato con successo' : 'Erroe durante la modifica',
        life: 5000
      });
      this.editingRowId = null;
      this.caricaInfissi();
    });
  }

  resetForm() {
    this.infissoForm.reset();
    this.infissoForm.get('dse_id')?.setValue(0);
    this.infissoForm.get('dse_lavoro_id')?.setValue(this.idLavoro);
    this.infissoForm.get('dse_step')?.setValue('2.6');
    this.infissoForm.get('dse_occorrenze')?.setValue(1);

  }

  eliminaInfisso(Id: number) {
    this.confirmService.confirm({
      header: `Elimina Infssi`,
      message: 'Sicuro di Eseguire l\'operazione di Cancellazione?',
      icon: 'pi  pi-question-circle',
      accept: () => {
        this.dsEneaSrv.delDsEnea(Id).subscribe((res) => {
          this.messageSrv.add({
            key: 'tst',
            severity: res.res === 'ok' ? 'success' : 'error',
            summary: `Elimina`,
            detail: res.message,
            life: 8000 // Tempo in millisecondi (10 secondi)
          });
          this.caricaInfissi();
        })
      },
    });
  }

  abilitaModifica(id: number) {
    this.editingRowId = id;
  }

  annullaModifica() {
    this.editingRowId = null;
    this.caricaInfissi();
  }

}